/**
  * THIS IS A GENERATED FILE. DO NOT ALTER DIRECTLY.
  */

 ;
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgScrollClick = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" fillRule="evenodd" d="m6.582 8.005 1.06 1.061-3.005 3.005 3.006 3.005-1.061 1.061L3.4 12.955c-.533-.533-.534-1.234 0-1.768zM17.416 16.132l-1.06-1.06 3.005-3.006-3.006-3.005L17.417 8l3.182 3.182c.533.533.534 1.234 0 1.768zM11.997 14.068a2 2 0 1 0 0-4 2 2 0 0 0 0 4m0 1.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" clipRule="evenodd" /></svg>;
export default SvgScrollClick;